import {inject, bindable, customElement} from 'aurelia-framework';
import Backend from "../backend";
import {ShoppingCart} from "./checkout-flow/shopping-cart";
import {Router} from "aurelia-router";
import {CheckoutFlowScreen} from "./checkout-flow/checkout-flow-screen";

@customElement('crate-choice-modal-component')
@inject(Element, Backend, ShoppingCart, Router)
export class CrateChoiceModalComponent {
  // DI
  element;
  backend;
  shoppingCart;
  router;

  // View models
  crateChoiceModalRef;

  // Data fields
  crateProducts
  crateProductsNonCustomizable;
  crateProductsCustomizable;

  constructor(element, backend, shoppingCart, router) {
    this.element = element;
    this.backend = backend;
    this.shoppingCart = shoppingCart;
    this.router = router;
  }

  bind() {
    // Load crate product info
    this.backend.CrateCatalogQueryHandler_handle()
      .then(result => {
        this.crateProducts = result.items;

        // Split into customizable and not
        this.crateProductsNonCustomizable = result.items.filter(crate => !crate.isCustomizable);
        this.crateProductsCustomizable = result.items.filter(crate => crate.isCustomizable);

        // Pick randomly a single customizable crate to be default.
        this.defaultCustomizableCrateProduct = this.crateProductsCustomizable[0];
      });
  }

  /**
   * @param chosenProducts after crate is chosen we will need to know which subproducts should be added to the crate.
   * @param selectedProductCategorySeoKey which sub product category should be shown (if applicable) after redirecting to other screen.
   */
  show(chosenProducts, selectedProductCategorySeoKey) {
    this.chosenProducts = chosenProducts;

    // Don't show modal, just use default crate type
    // Set products
    this.setCrateProductAndChosenSubProducts(this.defaultCustomizableCrateProduct.productId)
      // Go to checkout flow, but not summary step like when manually choosing a crate type.
      // We want the customer to keep browsing sub products, we just can't do it on the screen we were on because
      // there is no "next" button.
      .then(() => this.router.navigateToRoute('checkout-flow', {step: CheckoutFlowScreen.CUSTOMIZABLE_CONTENT_STEP, selectedProductCategorySeoKey: selectedProductCategorySeoKey}));


    // Show modal
    // Old logic
    //this.crateChoiceModalRef.open();
  }

  chooseCrateButtonClicked(crateProductId) {
    // Set products
    this.setCrateProductAndChosenSubProducts(crateProductId)
      // Go to checkout flow
      .then(() => this.router.navigateToRoute('checkout-flow', {step: CheckoutFlowScreen.SUMMARY_OR_INTERVAL_AND_SUMMARY_STEP}));
  }

  setCrateProductAndChosenSubProducts(crateProductId) {
    // Set crate product
    return this.shoppingCart.setCrateProductId(crateProductId)
      .then(() => {
        // Store chosen sub products in shopping cart
        this.chosenProducts
          // The SubProductComponent allows quantity zero if initValues was non-zero because it should be possible to remove items,
          // but we don't want anything to be removed because of what we are doing here.
          .filter(product => product.quantity > 0)
          .forEach(product => this.shoppingCart.addSubProduct(product.productId, product.quantity));
      });
  }
}
